import api from '@/lib/axios';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export type LeaveStatus = 0 | 1 | 2;

export interface OrgSchoolOption {
  id: string;
  name: string;
}

export interface LeaveRow {
  id: string;
  userId: string;
  userName: string | null;
  reason: string;
  fromDate: string;
  toDate: string;
  status: LeaveStatus;
  days: number;
  createdAt: string;
  leaveDetails: { date: string; type: string }[];
}

export interface LeaveListParams {
  status?: LeaveStatus;
  academicYearId?: string;
  month?: number;
  userId?: string;
}

export interface StaffOption {
  id: string;
  name: string | null;
}

export interface MonthlyLeaveRow {
  month: string;
  allocated: number;
  usedCl: number;
  usedLwp: number;
  usedTotal: number;
  remainingCl: number;
  remainingTotal: number;
}

export interface LeaveReport {
  configured: boolean;
  monthlyAllowedLeaves: number | null;
  academicYearId: string | null;
  userName: string | null;
  months: MonthlyLeaveRow[];
}

export const OrgLeaveManagementApi = {
  schools: async (): Promise<OrgSchoolOption[]> => unwrap(await api.get('/org/leave-management/schools')),

  list: async (schoolId: string, params?: LeaveListParams): Promise<LeaveRow[]> =>
    unwrap(await api.get('/org/leave-management', { params: { schoolId, ...params } })),

  staffOptions: async (schoolId: string): Promise<StaffOption[]> =>
    unwrap(await api.get('/org/leave-management/staff', { params: { schoolId } })),

  /** `userId` is required — real legacy's own /leave/report always scopes to one staff member. */
  report: async (schoolId: string, userId: string, academicYearId?: string): Promise<LeaveReport> =>
    unwrap(await api.get('/org/leave-management/report', { params: { schoolId, userId, academicYearId } })),

  updateStatus: async (id: string, schoolId: string, status: LeaveStatus): Promise<LeaveRow> =>
    unwrap(await api.patch(`/org/leave-management/${id}/status`, { status }, { params: { schoolId } })),
};
